__turbopack_context__.v({
  "section": "latest-news-item-module-scss-module__KCw7xW__section",
  "section-date": "latest-news-item-module-scss-module__KCw7xW__section-date",
  "section-read-more": "latest-news-item-module-scss-module__KCw7xW__section-read-more",
  "section-title": "latest-news-item-module-scss-module__KCw7xW__section-title",
  "section-top": "latest-news-item-module-scss-module__KCw7xW__section-top",
});
